import React from 'react';

const stats = [
  '$2.1B+ U.S. Peptide Market',
  '340+ Compounds Tracked',
  '61% Suppliers Now COA-Verified',
  '200K+ Industry Subscribers',
  '38 Facilities Added to Import Alert 66-40',
  '47% Surge in Domestic API Inquiries',
  '$340M+ in Domestic Capacity Investments',
];

export default function StatsTicker() {
  const doubled = [...stats, ...stats];

  return (
    <div className="bg-foreground text-white py-2 ticker-wrap border-b border-white/10 overflow-hidden">
      <div className="ticker-move flex items-center gap-0">
        {doubled?.map((stat, i) => (
          <React.Fragment key={`ticker-${i}`}>
            <span className="text-xs font-600 text-white/80 whitespace-nowrap px-4">{stat}</span>
            <span className="text-primary font-700 text-xs flex-shrink-0">●</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}